import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {bzIconArrowDown, bzIconArrowLeft, bzIconArrowUp, bzIconChevronLeft, bzIconChevronRight, bzIconMapOutline} from '@bringoz/ui/icons';

/**
 * Header of the timecard detail: back to the list, the agent select (projected from the AngularJS shell),
 * day navigation, map toggles and Add Stop.
 */
require('./timecard-detail-header.scss');
@Component({
  standalone: false,
  selector: 'app-timecard-detail-header',
  templateUrl: './timecard-detail-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimecardDetailHeaderComponent {

  readonly isAgentView = input<boolean>(false);
  readonly fromDate = input<number>();
  readonly configTimeZone = input<string>();
  readonly isMapTimelineVisible = input<boolean>(true);
  readonly isRoutePanelVisible = input<boolean>(false);
  readonly isAddStopDisabled = input<boolean>(true);
  /** Translation key explaining why Add Stop is disabled, if it is. */
  readonly addStopHint = input<string>();

  readonly back = output<void>();
  readonly browseDay = output<boolean>();
  readonly dateChange = output<number>();
  readonly toggleMapTimeline = output<void>();
  readonly toggleRoutePanel = output<void>();
  readonly addStop = output<void>();

  readonly icons = {
    back: bzIconArrowLeft,
    previous: bzIconChevronLeft,
    next: bzIconChevronRight,
    map: bzIconMapOutline,
    routePanelOpen: bzIconArrowDown,
    routePanelClosed: bzIconArrowUp
  };
}
